import { render, staticRenderFns } from "./Problems.vue?vue&type=template&id=30d687c2&scoped=true&"
import script from "./Problems.vue?vue&type=script&lang=js&"
export * from "./Problems.vue?vue&type=script&lang=js&"
import style0 from "./Problems.vue?vue&type=style&index=0&id=30d687c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d687c2",
  null
  
)

export default component.exports